import PropTypes from "prop-types";
import React from "react";

import Image from "~components/atoms/image/image";
import LinkWrapper from "~components/utils/link_wrapper/link_wrapper";

import { LINK } from "../../../prop_types";
import * as classes from "./image_link.module.scss";

export default function ImageLink({ link, onClick, ...props }) {
  return (
    <LinkWrapper link={link} onClick={onClick}>
      <div className={classes.imageLink} type="button">
        <Image {...props} />
      </div>
    </LinkWrapper>
  );
}

ImageLink.defaultProps = {
  link: null,
  onClick: null,
};

ImageLink.propTypes = {
  link: LINK,
  onClick: PropTypes.func,
};
